import actions from "~/shared/actions";
import * as server from "~/shared/api/server";
import dispatchers from "~/shared/dispatchers";

export function updateInvestmentProfile(polisenummer, newInvestmentProgram) {
	return (dispatch, getState) => {
		dispatch(
			actions.investmentProfileUpdateRequest({
				polisenummer,
				newInvestmentProgram,
			}),
		);
		const policy = getState().policies.list.find((p) => p.polisenummer === polisenummer);
		return server
			.updateInvestmentProfile(polisenummer, newInvestmentProgram)
			.then(({ manualStepsRequired }) =>
				Promise.all([
					Promise.resolve(manualStepsRequired),
					dispatchers.loadPolicyDetails(polisenummer)(dispatch, getState),
					dispatchers.loadHoldings(polisenummer)(dispatch),
					dispatchers.loadPolicyPrices(polisenummer, policy.produktId)(dispatch),
					policy.sb1PrognoseStotte && dispatchers.loadPolicyPrognosis({ polisenummer })(dispatch),
				]),
			)
			.then(([manualStepsRequired]) =>
				dispatch(
					actions.investmentProfileUpdateResponse({
						polisenummer,
						newInvestmentProgram,
						manualStepsRequired,
					}),
				),
			);
	};
}

export function loadOpenInvestmentFunds(polisenummer, retryLoading = true) {
	return (dispatch, getState) => {
		dispatch(actions.openInvestmentFundsRequest({ polisenummer }));
		const policy = getState().policies.list.find((p) => p.polisenummer === polisenummer);
		if (!policy) {
			if (retryLoading) {
				return dispatchers
					.loadPolicies()(dispatch)
					.then(() => loadOpenInvestmentFunds(polisenummer, false)(dispatch, getState));
			}
			return dispatch(dispatchers.dispatchError(new Error(`Unknown policy: ${polisenummer}`)));
		}
		return server.getOpenInvestmentFunds(polisenummer).then(({ openInvestmentFunds }) => {
			dispatch(
				actions.openInvestmentFundsResponse({
					polisenummer,
					openInvestmentFunds,
				}),
			);
		});
	};
}

export function updateOpenInvestmentFunds(polisenummer, funds, recommendedShareProportion, shareProportion, withinRecommendation, reminder) {
	return (dispatch, getState) => {
		dispatch(
			actions.openInvestmentFundsUpdateRequest({
				polisenummer,
				funds,
				recommendedShareProportion,
				withinRecommendation,
				reminder,
			}),
		);
		const policy = getState().policies.list.find((p) => p.polisenummer === polisenummer);
		return server
			.updateOpenInvestmentFunds(polisenummer, funds, recommendedShareProportion, shareProportion, withinRecommendation, reminder)
			.then(() =>
				Promise.all([
					dispatchers.loadPolicyDetails(polisenummer)(dispatch, getState),
					dispatchers.loadHoldings(polisenummer)(dispatch),
					policy.sb1PrognoseStotte && dispatchers.loadPolicyPrognosis({ polisenummer })(dispatch),
				]),
			)
			.then(() => {
				dispatch(
					actions.openInvestmentFundsUpdateResponse({
						polisenummer,
						newOpenInvestmentFunds: funds,
						recommendedShareProportion,
						shareProportion,
						withinRecommendation,
						reminder,
					}),
				);
			});
	};
}
